import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import withAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import {
  PRODUCT_ROLES,
  GLOBAL_ROLES,
  PROJECT_ROLES,
  ROUTE_ROLES
} from 'containers/Role/constants'

const RoleLink = withAnyRoles(Link)

const CreateLink = (props) => {
  return (
    <RoleLink
      roles={
        [
          GLOBAL_ROLES.CLIENT_ACCESS,
          GLOBAL_ROLES.ADMIN_ACCESS,
          ROUTE_ROLES.PROJECT_CREATE,
          PRODUCT_ROLES.PRODUCT_APPLICATIONS_ENGINEER,
          PROJECT_ROLES.CUSTOMER_PROGRAM_MANAGER,
          PROJECT_ROLES.ACCOUNT_APPLICATIONS_ENGINEER,
          PROJECT_ROLES.APPLICATIONS_ENGINEERING_MANAGER,
        ]
      }
      {...props}
    />
  )
}

export default CreateLink
